import React, { Fragment } from "react";
import { deBaseAFechaLocal } from "../../../utils/Tools";

const PasajesSection = (props) => {
  const {
    transporte,
    fechaSalida,
    puntosDeEmbarques = [],
    puntoDeEmbarque,
  } = props;
  let puntoEmbarque = puntosDeEmbarques.find(
    (emb) => puntoDeEmbarque.idPuntoDeEmbarque === emb.idPuntoDeEmbarque,
  ) || { idPuntoDeEmbarque: 0 };

  // 2. Si es nulo (o undefined) y es un vuelo, aplicamos el fallback al primero de la lista
  if (
    (!puntoEmbarque || puntoEmbarque.idPuntoDeEmbarque === 0) &&
    transporte.descripcion === "AER" &&
    puntosDeEmbarques.length > 0
  ) {
    puntoEmbarque = puntosDeEmbarques[0];
  }

  let textoCustom = "";
  if (
    puntoEmbarque &&
    puntoEmbarque.idPuntoDeEmbarque !== 0 &&
    transporte.descripcion === "BUS"
  ) {
    textoCustom = `Presentarse el ${deBaseAFechaLocal(puntoEmbarque.fechaHora)} en ${puntoEmbarque.denominacion}`;
  }

  if (
    puntoEmbarque &&
    puntoEmbarque.idPuntoDeEmbarque !== 0 &&
    transporte.descripcion === "AER"
  ) {
    textoCustom = `Presentarse el ${deBaseAFechaLocal(puntoEmbarque.fechaHora)} a las ${puntoEmbarque.hora} en ${puntoEmbarque.denominacion}`;
  }

  return (
    <div className="card pasajes">
      <div className="card-header" id="headingOne">
        <h5>
          <button
            className="btn btn-link"
            data-toggle="collapse"
            data-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            Pasajes
            <i className="material-icons">keyboard_arrow_up</i>
          </button>
        </h5>
      </div>
      <div
        id="collapseOne"
        className="collapse accordion-info show"
        aria-labelledby="headingOne"
        data-parent="#accordion"
      >
        <div className="card-body">
          <ul className="pasajes">
            <li>
              <h6>
                {transporte.descripcion} - {transporte.categoria}
              </h6>
            </li>
            <li>
              <h6>
                <strong>Fecha Salida:</strong> {deBaseAFechaLocal(fechaSalida)}
              </h6>
            </li>

            {puntoEmbarque !== "" && (
              <div>
                {puntoEmbarque.denominacion !== "" && (
                  <li>
                    <h6>
                      <strong>Embarque: </strong>
                      {textoCustom}
                    </h6>
                  </li>
                )}

                {puntoEmbarque.denominacion !== "" && (
                  <li>
                    <h6>
                      <strong>Dirección:</strong> {puntoEmbarque.direccion}
                    </h6>
                  </li>
                )}

                {puntoEmbarque.textoEmbarque !== "" && (
                  <li>
                    <h6>
                      <strong>Detalle:</strong> {puntoEmbarque.textoEmbarque}
                    </h6>
                  </li>
                )}
              </div>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PasajesSection;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/FichaReserva/pasajesSection.js